import { useState } from 'react';

import {
  AlertTriangle,
  Error,
  VFlex,
  VLoadingSpinner,
  VStack,
} from '@/package';

const ModelingVideo = ({ src }: { src: string }) => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="flex size-full items-start justify-center">
      <VStack gap={0.5} className="w-full">
        <div className="text-headline-sm font-semibold">
          Qualitative Evaluation
        </div>
        <VFlex className="relative h-[458px] w-full items-center justify-center">
          {src ? (
            <>
              {isLoading && (
                <VStack
                  className="absolute top-0 left-0 z-10 size-full bg-white/90 text-black"
                  items="center"
                  justify="center"
                  gap={0.5}
                >
                  <VLoadingSpinner className="!size-10 !text-status-inProgress" />
                  Loading...
                </VStack>
              )}
              {error && (
                <VStack
                  className="absolute top-0 left-0 z-10 size-full bg-white/90 text-error-500"
                  items="center"
                  justify="center"
                  gap={0.5}
                >
                  <AlertTriangle className="size-10" />
                  {error}
                </VStack>
              )}
              <video
                src={src}
                controls
                muted
                autoPlay
                loop
                className="h-full w-full rounded-md bg-black"
                onLoadStart={() => setIsLoading(true)}
                onLoadedData={() => setIsLoading(false)}
                onError={() => {
                  setError('Error playing video');
                  setIsLoading(false);
                }}
              />
            </>
          ) : (
            <VStack
              className="absolute top-0 left-0 z-10 size-full bg-white/90 text-error-500"
              items="center"
              justify="center"
              gap={0.5}
            >
              <Error className="size-10" />
              Not found video
            </VStack>
          )}
        </VFlex>
      </VStack>
    </div>
  );
};

export default ModelingVideo;
